import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/contentsets/:id?',
      name: 'contentsets',
      component: () =>
        import(/* webpackChunkName: "contentsets-page" */ './pages/ContentSetsPage.vue'),
    },
  ],
  Module.CONTENTSET
);
